import { render, staticRenderFns } from "./ProjectSummaryStretchGoalCompleted.vue?vue&type=template&id=bef22d68"
import script from "./ProjectSummaryStretchGoalCompleted.vue?vue&type=script&lang=js"
export * from "./ProjectSummaryStretchGoalCompleted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports